import React, { useEffect, useRef } from "react";
import './HomePage.scss';
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function HomePage() {

    return (
        <div className="HomePage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>HandyBy | Find Verified Home Service Pros Near You</title>

                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="HandyBy | Find Trusted Local Pros" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="HandyBy | Find Trusted Local Pros" data-react-helmet="true" />

                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.handyby.com/og-image.jpg" data-react-helmet="true" />

                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.handyby.com/" data-react-helmet="true" />

                {/* <!-- Maximum of 155 characters --> */}
                <meta name="description" content="HandyBy Connects Homeowners With Verified, Trusted Professionals For All Home Services Including Air Duct Cleaning, HVAC Repair, Chimney Sweep, And Roofing." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="HandyBy Connects Homeowners With Verified, Trusted Professionals For All Home Services Including Air Duct Cleaning, HVAC Repair, Chimney Sweep, And Roofing." data-react-helmet="true" />

                <meta name="og:site_name" property="og:site_name" content="HandyBy" data-react-helmet="true" />

                <meta name="keywords" content="Find Pros Near Me, Local Contractors, Air Duct Cleaning, Chimney Sweep, Dryer Vent Cleaning, HVAC Services, Roofing Services, Home Repair Pros, Verified Professionals, HandyBy, Trusted Home Services, Home Service Platform, Local Handyman, HVAC Repair, Roof Repair, Chimney Inspection, Duct Repair, Chimney Cleaning, Roofing Company, Emergency Home Service, Install Service, Repair Service, Clean Service, Home Improvement Pros" data-react-helmet="true" />
            </Helmet>
            <div className="HomePageColor">
                <img src={require(`../../EmetyaImages/middle-age-greyhaired-man-wearing-casual-clothes-doing-happy-thumbs-up-gesture-with-hand-approving-expression-looking-camera-showing-success.jpg`)} alt="" />
            </div>
        </div>
    )
}

